export default [
  {
    unit: "Nursing unit",
    subUnits: [
      "OPD",
      "Emergency ward",
      "Female ward",
      "Male ward",
      "Public health (HBSS clinics)",
      "Public health (Infant welfare clinic)",
      "Public health (Ante-natal booking clinic)",
      "Public health (Immunization clinics)",
      "Public health (Ante-natal clinics)",
      "Family planning",
      "Maternity ward",
      "Operating room theatre",
      "Dressing room",
    ],
  },
  {
    unit: "Consulting unit",
    subUnits: [
      "Emergency",
      "General outpatient clinic",
      "Hypertensive clinic",
      "Antenatal clinic",
      "Eye clinic",
      "Physiotherapy clinic",
    ],
  },
  {
    unit: "Pathology laboratory unit",
    subUnits: [
      "Reception",
      "Heamatology lab",
      "Chemical pathology lab",
      "Microbiology lab",
    ],
  },
  {
    unit: "Pharmacy unit",
    subUnits: [
      "Store and logistics",
      "Main pharmacy",
      "Drug production unit",
      "Pharmaceutical care/clinical pharmacy",
      "Pharmacy phase II",
    ],
  },
  {
    unit: "Medical record unit",
    subUnits: ["Record officer"],
  },
  {
    unit: "Administration",
    subUnits: ["Admin officer"],
  },
  {
    unit: "Cash point",
    subUnits: ["Cash point officer"],
  },
];
